// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import React from 'react'

import {
  daycareAssistanceLevels,
  preschoolAssistanceLevels
} from 'lib-common/generated/api-types/assistance'
import type { EmployeeCustomizations } from 'lib-customizations/types'

import { employeeConfig } from './appConfigs'
import MunicipalityLogo from './assets/municipality-logo-primary.svg'
import featureFlags from './featureFlags'

const customizations: EmployeeCustomizations = {
  appConfig: employeeConfig,
  translations: {
    fi: {
      common: {
        retroactiveConfirmation: {
          checkboxLabel:
            'Ymmärrän, olen asiasta yhteydessä laskutustiimiin ka.varhaiskasvatus@kajaani.fi *'
        }
      },
      footer: {
        cityLabel: 'Kajaani kaupunki',
        linkLabel: 'Kajaanin varhaiskasvatus',
        linkHref: 'https://www.kajaani.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatus/'
      },
      unitEditor: {
        placeholder: {
          email: 'etunimi.sukunimi@kajaani.fi',
          url: 'esim. https://www.kajaani.fi/fi/toimipisteet/15585',
        }
      },
      welcomePage: {
        text: 'Olet kirjautunut sisään Kajaanin kaupungin eVaka-palveluun. Käyttäjätunnuksellesi ei ole vielä annettu oikeuksia, jotka mahdollistavat palvelun käytön. Tarvittavat käyttöoikeudet saat omalta esimieheltäsi.'
      },
      preferredFirstName: {
        description:
      'Voit määritellä eVakassa käytössä olevan kutsumanimesi. Kutsumanimen tulee olla jokin etunimistäsi. Jos nimesi on vaihtunut ja sinulla on tarve päivittää eVakaan uusi nimesi, ole yhteydessä Kajaanin tukeen.',
      },
      login: {
        loginAD: 'Kajaanin AD',
      },
      incomeStatement: {
        noIncomeTitle:
        'Ei mitään tuloja tai tukia, tiedot saa tarkastaa Kelasta',
        incomesRegister:
          'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan Kelasta.',
        checkupConsent:
        'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tarvittaessa Kelasta.',
        limitedCompanyIncomesRegister:
        'Tuloni voi tarkastaa tarvittaessa Kelasta.',
      },
      absences: {
        absenceTypes: {
          PLANNED_ABSENCE: 'Ennalta ilmoitettu poissaolo',
        },
        absenceTypesShort: {
          PLANNED_ABSENCE: 'Ilmoitettu',
        },
        absenceTypeInfo: {
          PLANNED_ABSENCE:
            'Käytetään vain vuoroyksiköissä tai korjattavaan ilmoitettuun poissaoloon, jossa halutaan antaa palvelutarpeen tunnit takaisin käytettäväksi huoltajalle.',
        },
         modal: {
          absenceTypes: {
            PLANNED_ABSENCE: 'Ennalta ilmoitettu poissaolo',
          },
        }
      },
    },
    sv: {},
  },

  cityLogo: <img src={MunicipalityLogo} alt="Kajaani logo" data-qa="footer-city-logo" />,
  featureFlags,
  placementTypes: [
    'PRESCHOOL',
    'PRESCHOOL_DAYCARE',
    'DAYCARE',
    'DAYCARE_PART_TIME',
    'PREPARATORY',
    'PREPARATORY_DAYCARE',
    'CLUB',
    'TEMPORARY_DAYCARE',
    'TEMPORARY_DAYCARE_PART_DAY',
  ],
  absenceTypes: [
    'OTHER_ABSENCE',
    'SICKLEAVE',
    'UNKNOWN_ABSENCE',
    'PLANNED_ABSENCE',
    'PARENTLEAVE',
    'FORCE_MAJEURE',
  ],
  daycareAssistanceLevels: [...daycareAssistanceLevels],
  otherAssistanceMeasureTypes: [
    'TRANSPORT_BENEFIT',
    'ACCULTURATION_SUPPORT',
    'ANOMALOUS_EDUCATION_START',
  ],
  placementPlanRejectReasons: ['REASON_1', 'REASON_2', 'OTHER'],
  preschoolAssistanceLevels: [...preschoolAssistanceLevels],
  unitProviderTypes: [
    'MUNICIPAL',
    'PURCHASED',
    'PRIVATE',
    'MUNICIPAL_SCHOOL',
    'PRIVATE_SERVICE_VOUCHER',
    'EXTERNAL_PURCHASED',
  ],
  voucherValueDecisionTypes: [
    'NORMAL',
    'RELIEF_ACCEPTED',
    'RELIEF_PARTLY_ACCEPTED',
    'RELIEF_REJECTED',
  ],
  additionalStaffAttendanceTypes: [
    'OTHER_WORK',
    'TRAINING',
    'JUSTIFIED_CHANGE',
    'SICKNESS',
    'CHILD_SICKNESS',
  ],

}

export default customizations
